
'use strict';

var React = require('react');
var classNames = require('classnames');

var Link = React.createClass({
	displayName: 'TMA__LINK',
	propTypes: {
		href: React.PropTypes.string,
		text: React.PropTypes.string
	},
	render: function () {
		var {href, children, ...other} = this.props;

		if(!href) {
			return (
				<span>{children}</span>
			);
		}

		return (
			<span className="svtse_vma__read-more">
				<a href={href} {...other}>{children}</a>
			</span>
		);

	}
});

module.exports = React.createClass({
	displayName: 'TMA',

	propTypes: {
		message: React.PropTypes.shape({
			link: React.PropTypes.string,
			linkText: React.PropTypes.string,
			text: React.PropTypes.string.isRequired
		})
	},

	render: function () {
		var message = this.props.message;
		if (!message) {
			return false;
		}

		var classes = classNames('svtse_tma', this.props.className);

		if(message.link && message.linkText) {
			return (
				<div className={classes}>
					<div className="svtse_tma__holder">
						<article className="svtse_tma__article">
							<p>
								<span className="svtse_tma__message">{message.text}</span>

								<Link className="svtse_tma__read-more-link" href={message.link}>{message.linkText}</Link>

							</p>
						</article>
					</div>
				</div>
			);
		}

		return (
			<div className={classes}>
				<div className="svtse_tma__holder">
					<article className="svtse_tma__article">
						<p>
							<span className="svtse_tma__message">{message.text}</span>
						</p>
					</article>
				</div>
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/TMA/index.js
 **/